import { stateGetters, stateSetters } from '@/utils/store/store-utils'

// Draft of what the user has checked in the intro-item picker
// (PickIntroItems.vue): source refs `{ itemId, collectionId }` for the items
// to copy into the target collection's description.
//
// It lives in the store rather than in the picker component because the picker
// allows detours — opening an item's detail page or creating a new item via
// /bookmarks/add etc. — which navigate away and remount the picker on return.
// Without this, everything checked before the round trip would be lost.
// Deliberately in-memory only (pattern: itemAddDetailsDraft): a draft is
// meaningful for one picking session, not across app launches.
const defaultState = {
  collectionId: null, // target collection the picks are for
  // [{ itemId, collectionId, introItemId? }] — collectionId = source collection;
  // introItemId marks an entry seeded from an already-saved intro item (its
  // copiedFrom is the itemId), so send can diff adds against removals.
  items: [],
  seeded: false, // existing intro items already loaded into `items` this session
}

export default {
  name: 'introItemsPickerDraft',
  namespaced: true,
  state: () => ({ ...defaultState }),
  getters: {
    ...stateGetters(defaultState),
  },
  mutations: {
    ...stateSetters(defaultState),
  },
  actions: {
    // Begin (or resume) the draft for a target collection. A different target
    // means the previous draft is stale and gets dropped.
    start({ state, commit }, { collectionId }) {
      if (state.collectionId === collectionId) return

      commit('resetState')
      commit('setCollectionId', collectionId)
    },
    setItems({ commit }, items) {
      commit('setItems', [...items])
    },
    // Pre-check the collection's saved intro items. Only once per picking
    // session — a resumed draft (returning from a detour) keeps the user's
    // toggles instead of re-seeding.
    seed({ state, commit }, entries) {
      if (state.seeded) return
      commit('setSeeded', true)
      commit('setItems', [...entries, ...state.items])
    },
    clear({ commit }) {
      commit('resetState')
    },
  },
}
